'use strict';

var chunkXKUEBHHQ_js = require('./chunk-XKUEBHHQ.js');

// src/cashier.ts
var Cashier = class {
  id;
  profileId;
  bartenderId;
  initialValue;
  transactions;
  carts;
  openeds;
  closedValues_user;
  closedValues_system;
  closed_at;
  created_at;
  updated_at;
  constructor(cashier) {
    this.id = cashier.id;
    this.profileId = cashier.profileId;
    this.bartenderId = cashier.bartenderId;
    this.initialValue = cashier.initialValue;
    this.transactions = cashier.transactions;
    this.carts = cashier.carts ? cashier.carts.map((cart) => new chunkXKUEBHHQ_js.Cart(cart)) : [];
    this.openeds = cashier.openeds ? cashier.openeds.map((opened) => new chunkXKUEBHHQ_js.TableOpened(opened)) : [];
    this.closedValues_user = cashier.closedValues_user;
    this.closedValues_system = cashier.closedValues_system;
    this.closed_at = cashier.closed_at;
    this.created_at = cashier.created_at;
    this.updated_at = cashier.updated_at;
  }
  getTotalTransactions({
    withInitialValue = true,
    type,
    onlyTransactions = false,
    includeIntegrations = true
  }) {
    let result = 0;
    if (type === "income") {
      result = this.transactions.filter((transaction) => {
        if ("formsPayment" in transaction && !includeIntegrations) {
          return false;
        }
        if (transaction.type === "income") {
          const obs = transaction.obs || "";
          return onlyTransactions ? !obs.includes("Encerramento mesa") : true;
        }
        return false;
      }).reduce((total, transaction) => total += transaction.value, 0);
      result += withInitialValue ? this.initialValue : 0;
    }
    if (type === "outcome") {
      result = this.transactions.filter((transaction) => transaction.type === "outcome").reduce((total, transaction) => total += Math.abs(transaction.value), 0);
    }
    return result;
  }
  getOnlyTableClousres() {
    return this.transactions.filter((transaction) => transaction.obs && transaction.obs.includes("Encerramento mesa")).reduce((total, transaction) => total += transaction.value, 0);
  }
  getTotalCartsValue({ type, withPayments = true, addressId }) {
    if (!addressId) {
      return this.carts.filter((cart) => cart.type === type).reduce((total, cart) => total += cart.getTotalValue("total"), 0);
    }
    if (withPayments) {
      return this.carts.filter((cart) => cart.type === type).flatMap((cart) => cart.formsPayment).reduce((total, formPayment) => total += formPayment.value, 0);
    } else {
      return this.carts.filter((cart) => cart.type === type).flatMap((cart) => cart.total).reduce((total, value) => total += value, 0);
    }
  }
};

exports.Cashier = Cashier;
